import { fade } from '@material-ui/core'

const styles = theme => ({
  mobile: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  empty: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '42px',
    color: fade(theme.palette.white, 0.6),
    backgroundColor: theme.palette.primary.main,
  },
  desktop: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.primary.main,
  },
  desktopContainer: {
    width: '100%',
    margin: '0 auto',
    maxWidth: theme.breakpoints.values.md,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 3),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(1, 4),
    },
  },
  text: {
    color: theme.palette.white,
  },
  cartAndButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  nextButton: {
    marginLeft: theme.spacing(2),
  },
  totalFirstInvoice: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  price: {
    ...theme.typography.h2,
    color: theme.palette.white,
    fontWeight: theme.typography.fontWeightBold,
    marginLeft: theme.spacing(2),
  },
  pricePrefix: {
    color: 'inherit',
    fontSize: '1.3rem',
    fontWeight: 'inherit',
    marginRight: theme.spacing(1),
  },
})

export default styles
